import {useEffect} from 'react';
import {sendEventToGA4} from 'app/helpers/gtagHelpers';

const pushVideoTracking = (video, category, value, videoIndex) => {
  sendEventToGA4('playlist_video_start', {
    video_provider: video.category,
    video_category: video.actionType,
    video_title: video.title,
    video_index: videoIndex,
    video_playlist: video.matchPlaylist,
  });
};

const useVideoStartTracking = (player, video, playerReady, playlist) => {
  useEffect(() => {
    const handleTimeupdate = () => {
      const currentTime = player?.currentTime();
      if (currentTime > 0) {
        const currentVideoIndex = playlist.indexOf(playlist.find(item => item.slug === video.slug));
        pushVideoTracking(video, 'video-started', 0, currentVideoIndex + 1);
        player.off('timeupdate', handleTimeupdate);
      }
    };
    if (player) {
      player.on('timeupdate', handleTimeupdate);
    }
    return () => {
      if (player) {
        player.off('timeupdate', handleTimeupdate);
      }
    };
  }, [video, player, playerReady]);
};

export {useVideoStartTracking};
